module.exports = __webpack_public_path__ + "img/f70.92e002f5.png";